import { Component, OnInit } from '@angular/core';


function aproposdefn() {
  alert("Bonjour !! \n\n Ceci est un mini-projet ISTIC pour le niveau LGLSI-2 en 2021 \n Réalisé par: Mohamed Dhia Jebali - Mariem Benjaballah - Aymen Tayari \n\n C'est une application web faite par angular pour la gestion des employés \n Vous pouvez ajouter, modifier, supprimer, chercher et consulter chaque employé dans la base de données de l'application");
}

async function deconnecter_fn() {
  var audio = new Audio('../assets/aud/exit.ogg');
  audio.play();
        localStorage.removeItem("connecteid");
        localStorage.removeItem("connectmdp");
        localStorage.removeItem("connectnom");
        window.location.href = '/connecter' ;

} ;

async function backend_tester_fn() {
  var eid = localStorage.getItem("connecteid");
  var motdepasse = localStorage.getItem("connectmdp");
  const rep = await fetch(`http://127.0.0.1:8000/gestionemployes/backend_connecter_bd?eid=${eid}&motdepasse=${motdepasse}`) ;   
  if (rep.ok){
    rep.json().then((data)=>{ 
      if (data.length != 0) {
        if (data[0].admin == 1) {
          (document.getElementById("connectnomm") as HTMLFormElement).insertAdjacentHTML("afterbegin",data[0].nom+" ") ;
        }
        if (data[0].admin == 0) {
          window.location.href = '/accueilemploye' ;
        }
      }
      else {
        localStorage.removeItem("connecteid");
        localStorage.removeItem("connectmdp");
        localStorage.removeItem("connectnom");
        window.location.href = '/connecter' ;
      }
    }) 
  } else {
    localStorage.removeItem("connecteid");
    localStorage.removeItem("connectmdp");
    localStorage.removeItem("connectnom");
    window.location.href = '/connecter' ;
  }
} ;

function hoversoundfn() {
  var audio = new Audio('../assets/aud/cursor.ogg');
audio.play();
}

function clicksoundfn() {
  var audio = new Audio('../assets/aud/select.ogg');
audio.play();
}

async function backend_ajouter_chercher_tache_fn() {

  var d1 = document.getElementById('ac') ;
  var t = (d1 as HTMLFormElement).innerHTML ;
  var c = 0 ;
  do {
    c++ ;
    t = t.replace('id="t',"|") ;
  } while (t.includes('id="t') == true) ;

  (document.getElementById("dt1") as HTMLFormElement).innerHTML = 	`<h2> <select style="width: 286px; font-size:18px;" name="dt1" id="dt1"> <option value="0">Directeur de cette Tâche (EID)</option> </select> </h2>`
  
  const rep = await fetch(`http://127.0.0.1:8000/gestionemployes/backend_ajouter_chercher_tache_bd`) ;   

  if (rep.ok){
    rep.json().then((data)=>{ 

      for(var j=0; j<data.length;j++) {
        
        (document.getElementById("dt1") as HTMLFormElement).insertAdjacentHTML("beforeend",`<option value="${data[j].eid}">${data[j].eid}</option>`) ; 
      }

    })
}


  
  for (var x=1 ; x < c ; x++) {
    

    (document.getElementById("dt"+x) as HTMLFormElement).innerHTML = 	`<h2> <select style="width: 286px; font-size:18px;" name="dt`+x+`" id="dt`+x+`"> <option value="0">Directeur de cette Tâche (EID)</option> </select> </h2>`
  
    const rep = await fetch(`http://127.0.0.1:8000/gestionemployes/backend_ajouter_chercher_tache_bd`) ;   
  
    if (rep.ok){
      rep.json().then((data)=>{ 

        for(var j=0; j<data.length;j++) {
          
          (document.getElementById("dt"+x) as HTMLFormElement).insertAdjacentHTML("beforeend",`<option value="${data[j].eid}">${data[j].eid}</option>`) ; 
        }

      })
  }

}

  }



function ajoutertachefn() {
  var d1 = document.getElementById('ac') ;
  var t = (d1 as HTMLFormElement).innerHTML ;
  var c = 1 ;
  do {
    c++ ;
    t = t.replace('id="t',"|") ;
  } while (t.includes('id="t') == true) ;

  var code = '<h2><input type="text" size=30 style="font-size:18px;" name="t' + c + '" id="t' + c + '" value="Nom de Tâche" pattern="[A-z0-9À-ž\s]{3,30}"></h2> <h2> <select style="width: 286px; font-size:18px;" name="dt' + c + '" id="dt' + c + '"> <option value="0">Directeur de cette Tâche (EID)</option> </select></h2> <br>' ;
  (d1 as HTMLFormElement).insertAdjacentHTML('beforeend',code) ;

  backend_ajouter_chercher_tache_fn() ;
 
}





@Component({
  selector: 'app-ajouter',
  templateUrl: './ajouter.component.html',
  styleUrls: ['./ajouter.component.css']
})
export class AjouterComponent implements OnInit {

  constructor() { }

  url!: string;

  
  onSelectFile(event:any){
    console.log("here");
    if (event.target.files && event.target.files[0]){
      var reader = new FileReader()
      reader.readAsDataURL(event.target.files[0])
      reader.onload = async (event) =>{
        this.url = event.target?.result as string;
      }
    }
  }

  ngOnInit(): void {
    backend_tester_fn() ;
    backend_ajouter_chercher_tache_fn();
    
  }


  aproposderun() {
    aproposdefn();
  }

    
  ajoutertache() {
    ajoutertachefn();
  }


  async backend_ajouter() {
  
  
    var b3 = false ;
  
    let url = "http://127.0.0.1:8000/gestionemployes/backend_ajouter_personne_bd" ;
    var cin = (document.getElementById("cin") as HTMLFormElement).value ;
    var prenom = (document.getElementById("prenom") as HTMLFormElement).value ;
    var nom = (document.getElementById("nom") as HTMLFormElement).value ;
    var datenaissance = (document.getElementById("dn") as HTMLFormElement).value ;
    var ville = (document.getElementById("ville") as HTMLFormElement).value ;
    var email = (document.getElementById("email") as HTMLFormElement).value ;
    var numtel = (document.getElementById("tel") as HTMLFormElement).value ;
    let post = `{"cin":"${cin}" , "prenom":"${prenom}" , "nom":"${nom}" , "datenaissance":"${datenaissance}" , "ville":"${ville}" , "email":"${email}" , "numtel":"${numtel}" , "photo":"${this.url}"}` 
    const rep = await fetch(url, {
      method:"POST" , 
      body : post
    })
  
    if (rep.ok){
  
    let url2 = "http://127.0.0.1:8000/gestionemployes/backend_ajouter_compte_bd" ;
    var eid = (document.getElementById("eid") as HTMLFormElement).value ;
    var motdepasse = (document.getElementById("motdepasse") as HTMLFormElement).value ;
    var admincb = (document.getElementById("admincb") as HTMLFormElement).checked ;
    var ad = 0 ;
    if (admincb == true) {ad = 1 ;}
    var dateinscriptionx = new Date();
    var dd = String(dateinscriptionx.getDate()).padStart(2, '0');
    var mm = String(dateinscriptionx.getMonth() + 1).padStart(2, '0'); 
    var yyyy = dateinscriptionx.getFullYear();
    var dateinscription = yyyy + '/' + mm + '/' + dd;
    var cin = (document.getElementById("cin") as HTMLFormElement).value ;
    var salaire = (document.getElementById("salaire") as HTMLFormElement).value ;
    let post2 = `{"eid":"${eid}" , "motdepasse":"${motdepasse}" , "ad":"${ad}" , "dateinscription":"${dateinscription}" ,  "salaire":"${salaire}" , "cin":"${cin}"}` 
    const rep2 = await fetch(url2, {
      method:"POST" , 
      body : post2
    })
  
    if (rep2.ok){
  
    let url3 = "http://127.0.0.1:8000/gestionemployes/backend_ajouter_tache_bd" ;
    var d1 = document.getElementById('ac') ;
    var t = (d1 as HTMLFormElement).innerHTML ;
    var c = 0 ;
    do {
      c++ ;
      t = t.replace('id="t',"|") ;
    } while (t.includes('id="t') == true) ;
  
    for (var i=1 ; i <= c ; i++) {
      var tnom = (document.getElementById("t"+i) as HTMLFormElement).value ;
      var deid = (document.getElementById("dt"+i) as HTMLFormElement).value ;
      var eid = (document.getElementById("eid") as HTMLFormElement).value ;
      let post3 = `{"tnom":"${tnom}" , "deid":"${deid}" , "eid":"${eid}"}` 
      var rep3 = await fetch(url3, {
        method:"POST" , 
        body : post3
      })
      if (rep3.ok){} else {b3 = true ;}
    }
  
    if (b3 == false) {  var audio = new Audio('../assets/aud/success.ogg');
    audio.play(); alert("L'insertion a réussi !")} 
  
    else { 
      var audio = new Audio('../assets/aud/erreur.ogg');
      audio.play(); 
      alert("L'insertion a échoué.\n\nAssurez-vous que le cin inséré n'existe pas dans la base de données et les données insérés sont valides.") ;
    } ;
  
    
    } else {
  
      let url2an = "http://127.0.0.1:8000/gestionemployes/backend_annuler_ajouter_personne_bd" ;
      let post2an = `{"cin":"${cin}"}`
      var rep2an = await fetch(url2an, {
        method:"POST" , 
        body : post2an
      })
  
      var audio = new Audio('../assets/aud/erreur.ogg');
      audio.play(); 
  
      alert("L'insertion a échoué.\n\nAssurez-vous que l'eid inséré n'existe pas dans la base de données et les données insérés sont valides.")
  
    } 
    } 
  
    
    
    else { 
      var audio = new Audio('../assets/aud/erreur.ogg');
      audio.play(); 
      alert("L'insertion a échoué.\n\nAssurez-vous que le cin inséré n'existe pas dans la base de données et les données insérés sont valides.")}
  
  
    } ;


  

  hoversound() {
    hoversoundfn();
  }

  clicksound() {
    clicksoundfn();
  }

  backend_ajouter_chercher_tache() {
    backend_ajouter_chercher_tache_fn();
  }

  deconnecter() {
    deconnecter_fn() 
  }




}
